<div class="c-form-field c-form-field--d -no-mb">
  <div class="c-form-field__inner -row">
    <input
      type="checkbox"
      [checked]="checked"
      [class.c-form-field__checkbox--permission]="checked === null"
      class="c-form-field__checkbox"
    />
    <label class="c-form-field__label" (click)="emitCheckboxChange()"></label>
    <ng-content></ng-content>
  </div>
</div>
